"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadStands = loadStands;
exports.loadStandsSucceeded = loadStandsSucceeded;
exports.loadStandsFailed = loadStandsFailed;
exports.loadMenu = loadMenu;
exports.loadMenuSucceeded = loadMenuSucceeded;
exports.loadMenuFailed = loadMenuFailed;
exports.createOrder = createOrder;
exports.createOrderSucceeded = createOrderSucceeded;
exports.createOrderFailed = createOrderFailed;
exports.loadConfigs = loadConfigs;
exports.loadConfigsSucceeded = loadConfigsSucceeded;
exports.loadConfigsFailed = loadConfigsFailed;
exports.loadConfig = loadConfig;
exports.loadConfigSucceeded = loadConfigSucceeded;
exports.loadConfigFailed = loadConfigFailed;
exports.updateConfig = updateConfig;
exports.updateConfigSucceeded = updateConfigSucceeded;
exports.updateConfigFailed = updateConfigFailed;
exports.createConfig = createConfig;
exports.createConfigSucceeded = createConfigSucceeded;
exports.createConfigFailed = createConfigFailed;
var STANDS_REQUESTED = 'STANDS_REQUESTED';
var STANDS_SUCCEEDED = 'STANDS_SUCCEEDED';
var STANDS_FAILED = 'STANDS_FAILED';
var MENU_REQUESTED = 'MENU_REQUESTED';
var MENU_SUCCEEDED = 'MENU_SUCCEEDED';
var MENU_FAILED = 'MENU_FAILED';
var CREATE_ORDER_REQUESTED = 'CREATE_ORDER_REQUESTED';
var CREATE_ORDER_SUCCEEDED = 'CREATE_ORDER_SUCCEEDED';
var CREATE_ORDER_FAILED = 'CREATE_ORDER_FAILED';
var GET_CONFIGS_REQUESTED = 'GET_CONFIGS_REQUESTED';
var GET_CONFIGS_SUCCEEDED = 'GET_CONFIGS_SUCCEEDED';
var GET_CONFIGS_FAILED = 'GET_CONFIGS_FAILED';
var GET_CONFIG_REQUESTED = 'GET_CONFIG_REQUESTED';
var GET_CONFIG_SUCCEEDED = 'GET_CONFIG_SUCCEEDED';
var GET_CONFIG_FAILED = 'GET_CONFIG_FAILED';
var UPDATE_CONFIG_REQUESTED = 'UPDATE_CONFIG_REQUESTED';
var UPDATE_CONFIG_SUCCEEDED = 'UPDATE_CONFIG_SUCCEEDED';
var UPDATE_CONFIG_FAILED = 'UPDATE_CONFIG_FAILED';
var CREATE_CONFIG_REQUESTED = 'CREATE_CONFIG_REQUESTED';
var CREATE_CONFIG_SUCCEEDED = 'CREATE_CONFIG_SUCCEEDED';
var CREATE_CONFIG_FAILED = 'CREATE_CONFIG_FAILED';

function loadStands(organizationName) {
  return {
    type: STANDS_REQUESTED,
    payload: {
      organizationName: organizationName
    }
  };
}

loadStands.type = STANDS_REQUESTED;

function loadStandsSucceeded(payload) {
  return {
    type: STANDS_SUCCEEDED,
    payload: payload
  };
}

loadStandsSucceeded.type = STANDS_SUCCEEDED;

function loadStandsFailed(payload) {
  return {
    type: STANDS_FAILED,
    payload: payload
  };
}

loadStandsFailed.type = STANDS_FAILED;

function loadMenu(menuId) {
  return {
    type: MENU_REQUESTED,
    menuId: menuId
  };
}

loadMenu.type = MENU_REQUESTED;

function loadMenuSucceeded(payload) {
  return {
    type: MENU_SUCCEEDED,
    payload: payload
  };
}

loadMenuSucceeded.type = MENU_SUCCEEDED;

function loadMenuFailed(payload) {
  return {
    type: MENU_FAILED,
    payload: payload
  };
}

loadMenuFailed.type = MENU_FAILED;

function createOrder(params) {
  return {
    type: CREATE_ORDER_REQUESTED,
    params: params
  };
}

createOrder.type = CREATE_ORDER_REQUESTED;

function createOrderSucceeded(payload) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: CREATE_ORDER_SUCCEEDED,
    payload: payload,
    extraData: extraData
  };
}

createOrderSucceeded.type = CREATE_ORDER_SUCCEEDED;

function createOrderFailed(payload) {
  var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return {
    type: CREATE_ORDER_FAILED,
    payload: payload,
    extraData: extraData
  };
}

createOrderFailed.type = CREATE_ORDER_FAILED;

function loadConfigs() {
  return {
    type: GET_CONFIGS_REQUESTED,
    payload: {
      id: id
    }
  };
}

loadConfigs.type = GET_CONFIGS_REQUESTED;

function loadConfigsSucceeded(payload) {
  return {
    type: GET_CONFIGS_SUCCEEDED,
    payload: payload
  };
}

loadConfigsSucceeded.type = GET_CONFIGS_SUCCEEDED;

function loadConfigsFailed(payload) {
  return {
    type: GET_CONFIGS_FAILED,
    payload: payload
  };
}

loadConfigsFailed.type = GET_CONFIGS_FAILED;

function loadConfig(id) {
  return {
    type: GET_CONFIG_REQUESTED,
    payload: {
      id: id
    }
  };
}

loadConfig.type = GET_CONFIG_REQUESTED;

function loadConfigSucceeded(payload) {
  return {
    type: GET_CONFIG_SUCCEEDED,
    payload: payload
  };
}

loadConfigSucceeded.type = GET_CONFIG_SUCCEEDED;

function loadConfigFailed(payload) {
  return {
    type: GET_CONFIG_FAILED,
    payload: payload
  };
}

loadConfigFailed.type = GET_CONFIG_FAILED;

function updateConfig(payload) {
  return {
    type: UPDATE_CONFIG_REQUESTED,
    payload: payload
  };
}

updateConfig.type = UPDATE_CONFIG_REQUESTED;

function updateConfigSucceeded(payload) {
  return {
    type: UPDATE_CONFIG_SUCCEEDED,
    payload: payload
  };
}

updateConfigSucceeded.type = UPDATE_CONFIG_SUCCEEDED;

function updateConfigFailed(payload) {
  return {
    type: UPDATE_CONFIG_FAILED,
    payload: payload
  };
}

updateConfigFailed.type = UPDATE_CONFIG_FAILED;

function createConfig(payload) {
  return {
    type: CREATE_CONFIG_REQUESTED,
    payload: payload
  };
}

createConfig.type = CREATE_CONFIG_REQUESTED;

function createConfigSucceeded(payload) {
  return {
    type: CREATE_CONFIG_SUCCEEDED,
    payload: payload
  };
}

createConfigSucceeded.type = CREATE_CONFIG_SUCCEEDED;

function createConfigFailed(payload) {
  return {
    type: CREATE_CONFIG_FAILED,
    payload: payload
  };
}

createConfigFailed.type = CREATE_CONFIG_FAILED;